import cloneDeep from 'lodash/fp/cloneDeep'
import { events } from './adviserProfileEducationEditorActions'
import { events as containerEvents } from '../AdviserProfileEditorContainer/adviserProfileEditorContainerActions'
import { validiateTextField } from '../../../common/forms/validationFunctions'

const initialState = {
  loadingEducation: false,
  editingQualification: false,
  editingQualificationIndex: -1,
  deletingQualificationModal: false,
  deletingQualificationIndex: -1,
  qualificationsBeforeEditing: [],
  studyStartYear: null,
  studyStartMonth: null,
  studyEndYear: null,
  studyEndMonth: null,
  isInvalid: {
    formIsValid: true,
    description: {
      valid: true,
      isInvalid: false,
      message: null
    },
    institution: {
      valid: true,
      isInvalid: false,
      message: null
    },
    startYear: {
      valid: true,
      isInvalid: false,
      message: null
    },
    startMonth: {
      valid: true,
      isInvalid: false,
      message: null
    },
    endYear: {
      valid: true,
      isInvalid: false,
      message: null
    },
    endMonth: {
      valid: true,
      isInvalid: false,
      message: null
    }
  }
}

const isFormValid = (state) => {
  let value = (state.education.isInvalid.description.valid &&
    state.education.isInvalid.institution.valid &&
    state.education.isInvalid.startYear.valid &&
    state.education.isInvalid.startMonth.valid &&
    state.education.isInvalid.endYear.valid &&
    state.education.isInvalid.endMonth.valid)
  return value
}

export default function (state = initialState, action) {
  var newState = copyEducationState(state)
  const { add, edit, set, deletes } = events
  let date
  switch (action.type) {
    case containerEvents.edit.cancel:
      newState.education = cloneDeep(initialState)
      return newState
    case add.qualification:
      newState.education.editingQualification = true
      newState.education.editingQualificationIndex = newState.profile.qualifications.length
      newState.education.qualificationsBeforeEditing = cloneDeep(newState.profile.qualifications)
      newState.profile.qualifications.push(action.qualification)
      newState.education.isInvalid = cloneDeep(initialState.isInvalid)
      newState.education.isInvalid.description.valid = false
      newState.education.isInvalid.institution.valid = false
      newState.education.isInvalid.startMonth.valid = true
      newState.education.isInvalid.endMonth.valid = true
      newState.education.isInvalid.startYear.valid = true
      newState.education.isInvalid.endYear.valid = true
      date = new Date(Date.now())
      newState.education.studyStartMonth = 0
      newState.education.studyStartYear = date.getFullYear() - 1
      newState.education.studyEndYear = date.getFullYear()
      newState.education.studyEndMonth = 11
      newState.profile.qualifications[newState.education.editingQualificationIndex].studyStartDate = date.toISOString()
      newState.education.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case edit.start:
      newState.education.editingQualification = true
      newState.education.editingQualificationIndex = action.index
      date = new Date(newState.profile.qualifications[newState.education.editingQualificationIndex].studyStartDate)
      newState.education.studyStartMonth = date.getMonth()
      newState.education.studyStartYear = date.getFullYear()
      if (newState.profile.qualifications[newState.education.editingQualificationIndex].studyEndDate !== null) {
        date = new Date(newState.profile.qualifications[newState.education.editingQualificationIndex].studyEndDate)
        newState.education.studyEndMonth = date.getMonth()
        newState.education.studyEndYear = date.getFullYear()
      }
      newState.education.qualificationsBeforeEditing = cloneDeep(newState.profile.qualifications)
      return newState
    case edit.stop:
      newState.education.editingQualification = false
      newState.education.editingQualificationIndex = initialState.editingQualificationIndex
      newState.education.studyStartMonth = initialState.studyStartMonth
      newState.education.studyStartYear = initialState.studyStartYear
      newState.education.studyEndMonth = initialState.studyEndMonth
      newState.education.studyEndYear = initialState.studyEndYear
      newState.education.isInvalid = cloneDeep(initialState.isInvalid)
      newState.education.qualificationsBeforeEditing = []
      newState.edited = true
      return newState
    case edit.cancel:
      newState.education.editingQualification = false
      newState.education.editingQualificationIndex = initialState.editingQualificationIndex
      newState.education.studyStartMonth = initialState.studyStartMonth
      newState.education.studyStartYear = initialState.studyStartYear
      newState.education.studyEndMonth = initialState.studyEndMonth
      newState.education.studyEndYear = initialState.studyEndYear
      newState.education.isInvalid = cloneDeep(initialState.isInvalid)
      newState.profile.qualifications = cloneDeep(newState.education.qualificationsBeforeEditing)
      newState.education.qualificationsBeforeEditing = []
      return newState
    case set.qualification:
      newState.profile.qualifications[newState.education.editingQualificationIndex] = cloneDeep(action.qualification)
      newState.education.isInvalid.institution = validiateTextField(action.qualification.institution, 255, true)
      newState.education.isInvalid.description = validiateTextField(action.qualification.description, 255, true)
      date = new Date(newState.profile.qualifications[newState.education.editingQualificationIndex].studyStartDate)
      date.setMonth(newState.education.studyStartMonth)
      date.setFullYear(newState.education.studyStartYear)
      newState.profile.qualifications[newState.education.editingQualificationIndex].studyStartDate = date.toISOString()
      if (newState.education.studyEndMonth !== null && newState.education.studyEndYear !== null) {
        date = new Date(newState.profile.qualifications[newState.education.editingQualificationIndex].studyEndDate)
        date.setMonth(newState.education.studyEndMonth)
        date.setFullYear(newState.education.studyEndYear)
        newState.profile.qualifications[newState.education.editingQualificationIndex].studyEndDate = date.toISOString()
      }
      newState.education.isInvalid.description = action.validationResult.description
      newState.education.isInvalid.institution = action.validationResult.institution
      newState.education.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case set.startMonth:
      newState.education.isInvalid.startMonth = cloneDeep(action.validationResult)
      newState.education.studyStartMonth = action.month
      newState.education.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case set.startYear:
      newState.education.studyStartYear = parseInt(action.year)
      newState.education.isInvalid.startYear = cloneDeep(action.validationResult)
      newState.education.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case set.endMonth:
      newState.education.isInvalid.endMonth = cloneDeep(action.validationResult)
      newState.education.studyEndMonth = action.month
      newState.education.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case set.endYear:
      newState.education.studyEndYear = parseInt(action.year)
      newState.education.isInvalid.endYear = cloneDeep(action.validationResult)
      newState.education.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case set.endDateCurrent:
      if (newState.profile.qualifications[newState.education.editingQualificationIndex].studyEndDate !== null) {
        newState.profile.qualifications[newState.education.editingQualificationIndex].studyEndDate = null
        newState.education.studyEndMonth = null
        newState.education.studyEndYear = null
        newState.education.isInvalid.endYear.valid = true
        newState.education.isInvalid.endMonth.valid = true
      } else {
        date = new Date(Date.now())
        newState.profile.qualifications[newState.education.editingQualificationIndex].studyEndDate = date.toISOString()
        newState.education.studyEndYear = date.getFullYear()
        newState.education.studyEndMonth = date.getMonth()
        newState.education.isInvalid.endYear.valid = true
      }
      newState.education.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case deletes.qualification:
      newState.profile.qualifications = newState.profile.qualifications.filter((qualification, index) => index !== newState.education.deletingQualificationIndex)
      newState.education.deletingQualificationIndex = initialState.deletingQualificationIndex
      newState.education.deletingQualificationModal = initialState.deletingQualificationModal
      newState.edited = true
      return newState
    case deletes.modal:
      newState.education.deletingQualificationModal = true
      newState.education.deletingQualificationIndex = action.index
      return newState
    case deletes.cancel:
      newState.education.deletingQualificationIndex = initialState.deletingQualificationIndex
      newState.education.deletingQualificationModal = initialState.deletingQualificationModal
      return newState
  }
  return state
}

function copyEducationState (state) {
  var newState = cloneDeep(state)
  newState.profile = cloneDeep(state.profile)
  if (state.profile) {
    newState.profile.educationPreferences = cloneDeep(state.profile.educationPreferences)
  }
  return newState
}
